import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { productsClient } from "@core/clients";
import { Product, ProductsQueryParams } from "@core/types";
import { PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

type UseGetProductByIdQueryOptions = {
  options: UseQueryOptions<Product>;
  params?: ProductsQueryParams;
};

const useGetProductByIdQuery = (
  id: string,
  zoneId: string,
  { options, params }: UseGetProductByIdQueryOptions = { options: {}, params: {} },
) => {
  // const queryClient = useQueryClient();

  return useQuery<Product, any>(
    ["products", id],
    async () => {
      if (!id) {
        throw new Error("useGetProductByIdQuery: invalid id");
      }
      return await productsClient.getProductById(id, zoneId, params);
    },
    {
      cacheTime: PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS,
      // Commented due to some differents between detail products and list products in IrsKom API
      // initialData: () => {
      //   const data = queryClient.getQueryData<Product[]>(["products"]);
      //   return data?.find((product) => String(product.id) === id);
      // },
      ...options,
    },
  );
};

export default useGetProductByIdQuery;
